import { render, staticRenderFns } from "./splitOkrWork.vue?vue&type=template&id=5fd1bc48&scoped=true&"
import script from "./splitOkrWork.vue?vue&type=script&lang=js&"
export * from "./splitOkrWork.vue?vue&type=script&lang=js&"
import style0 from "./splitOkrWork.vue?vue&type=style&index=0&id=5fd1bc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1bc48",
  null
  
)

component.options.__file = "splitOkrWork.vue"
export default component.exports